var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamMemberHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63492 6.25551C9.63492 5.00983 10.6298 4 11.8571 4C13.0844 4 14.0794 5.00983 14.0794 6.25551C14.0794 7.50119 13.0844 8.51102 11.8571 8.51102C10.6298 8.51102 9.63492 7.50119 9.63492 6.25551ZM6.85715 12.7401C6.85715 11.0529 10.1883 10.2026 11.8571 10.2026C13.526 10.2026 16.8571 11.0529 16.8571 12.7401V13.5859C16.8571 13.8971 16.6083 14.1498 16.3016 14.1498H7.4127C7.10604 14.1498 6.85715 13.8971 6.85715 13.5859V12.7401ZM21.1429 20.0002C20.6697 20.0002 20.2857 19.5898 20.2857 19.084V18.7786H3.71429V19.084C3.71429 19.5898 3.33029 20.0002 2.85714 20.0002C2.384 20.0002 2 19.5898 2 19.084V17.8625C2 17.3567 2.384 16.9463 2.85714 16.9463H11.1429V16.0299C11.1429 15.5242 11.5269 15.1138 12 15.1138C12.4731 15.1138 12.8571 15.5242 12.8571 16.0299V16.9463H21.1429C21.616 16.9463 22 17.3567 22 17.8625V19.084C22 19.5898 21.616 20.0002 21.1429 20.0002Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberHierarchy);
export default __webpack_public_path__ + "static/media/Team Member Hierarchy.98dcfb2b020c9f5560d2328e665cccec.svg";
export { ForwardRef as ReactComponent };